function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import { useEffect, useState } from 'react';
var subscribers = new Set();
var info; // 默认的响应式配置和 bootstrap 是一致的

var responsiveConfig = {
  xs: 0,
  sm: 576,
  md: 768,
  lg: 992,
  xl: 1200
};
/** 窗口大小改变的时候, 执行订阅器中的函数 */

function handleResize() {
  var oldInfo = info;
  calculate();

  if (oldInfo === info) {
    return;
  }

  var _iterator = _createForOfIteratorHelper(subscribers),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var subscriber = _step.value;
      subscriber();
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
}
/** 是否正在监听窗口变化 */


var listening = false;
/** 计算当前窗口大小是否 >= responsiveConfig 的 values */

function calculate() {
  var width = window.innerWidth;
  var newInfo = {}; // 某个值变了, 即需要更新

  var shouldUpdate = Object.keys(responsiveConfig).reduce(function (ret, key) {
    newInfo[key] = width >= responsiveConfig[key];

    if (newInfo[key] !== info[key]) {
      return true;
    }

    return ret;
  }, false);

  if (shouldUpdate) {
    info = newInfo;
  }
}
/** 修改config, 并重新计算 */


export function configResponsive(config) {
  responsiveConfig = config;

  if (info) {
    calculate();
  }
}

function useResponsive() {
  var windowExists = typeof window !== 'undefined';

  if (windowExists && !listening) {
    info = {};
    calculate();
    window.addEventListener('resize', handleResize);
    listening = true;
  }

  var _useState = useState(info),
      _useState2 = _slicedToArray(_useState, 2),
      state = _useState2[0],
      setState = _useState2[1];

  useEffect(function () {
    if (!windowExists) {
      return;
    } // 添加更新state的订阅


    var subscriber = function subscriber() {
      setState(info);
    };

    subscribers.add(subscriber); // 组件销毁后, 删除订阅 移除监听

    return function () {
      subscribers.delete(subscriber); // 为什么要判断size?

      if (subscribers.size === 0) {
        window.removeEventListener('resize', handleResize);
        listening = false;
      }
    };
  }, []);
  return state;
}

export default useResponsive;